module.exports = __webpack_public_path__ + "img/google_drive.cd1e9598.gif";